exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".person-quote{display:block}.person-quote .button{font-size:1em}.person-quote__wrapper{display:inline-block;padding-bottom:8px}.person-quote__image{cursor:pointer}.person-quote__action{position:relative;cursor:pointer;color:#e96661;font-size:.9em;margin-top:3px;text-align:center}.person-quote__action,.person-quote__action:hover{text-decoration:underline}.tooltip{max-width:40%;background-color:#e96661;color:#fff;padding:1em;margin-bottom:10px;border-radius:8px}.tooltip-inner{line-height:1.4em}.tooltip-arrow{border-right:5px solid transparent;border-left:5px solid transparent;left:50%;width:0;height:0;position:absolute}.tooltip[x-placement=top] .tooltip-arrow{border-top:10px solid #e96661;bottom:-10px}.tooltip[x-placement=bottom] .tooltip-arrow{border-bottom:10px solid #e96661;top:-10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42cf4648","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/quote/quote.vue
// module id = 58
// module chunks = 0